/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
import { useState, useEffect, useCallback } from "react";
import { Tooltip, Chip, Button, Grid } from "@material-ui/core";
import downloadFile from "../../../../../utils/commonFunctions/downloadFile";
import shortenFileName from "../../../../../utils/commonFunctions/shortenFileName";

import GetAppIcon from "@material-ui/icons/GetApp";
import PublishIcon from "@material-ui/icons/Publish";

import "./changeLogo.css";

const ChangeLogo = ({ logoSettings, handleLogoFileChange, handleImageDelete }) => {
	const [logoItems, setLogoItems] = useState([]);

	useEffect(() => {
		if (logoSettings && logoSettings.logo) {
			const {
				logo: { attachment },
				favicon
			} = logoSettings;
			setLogoItems([
				{
					buttonCaption: "Change Logo",
					handleLogoFileChange,
					file: attachment,
					handleImageDelete,
					name: "logo"
				},
				{
					buttonCaption: "Change Favicon",
					handleLogoFileChange,
					file: favicon,
					handleImageDelete,
					name: "favicon"
				}
			]);
		}
	}, [handleLogoFileChange, logoSettings, handleImageDelete]);

	return (
		<div className="change-logo">
			{logoItems.map((logoItem, index) => {
				const { buttonCaption, handleLogoFileChange, handleImageDelete, file, name } = logoItem;
				return (
					<Grid container key={index} className={index === 1 ? "favicon-container" : ""}>
						<Grid item xl={5} lg={5} md={12} sm={12} xs={12}>
							<input
								className={"logo-image-upload-" + index + ""}
								id={"logo-image-upload-" + index + ""}
								name={name}
								type="file"
								onChange={handleLogoFileChange}
								style={{ display: "none" }}
								accept="image/png, image/jpeg"
							/>
							<label htmlFor={"logo-image-upload-" + index + ""}>
								<Button
									className="button"
									component="span"
									variant="contained"
									style={{
										backgroundColor: "#3A4652",
										color: "#ffff",
										width: 190
									}}
								>
									<span className="button-label-with-icon" style={{ color: "#ffff" }}>
										{buttonCaption}
									</span>
									<span>
										<PublishIcon className="button-icon" style={{ color: "#ffff" }} />
									</span>
								</Button>
							</label>
						</Grid>
						<Grid item className="chipset" xl={4} lg={4} md={12} sm={12} xs={12}>
							{file ? (
								<Tooltip title={"Click to download"} arrow>
									<Chip
										label={
											file && file.originalname
												? shortenFileName(file.originalname)
												: file.name
												? shortenFileName(file.name)
												: "No files added"
										}
										//label={shortenFileName(file.name)}
										//label={file.name}
										onDelete={() => handleImageDelete(name)}
										onClick={() => downloadFile(file)}
									/>
								</Tooltip>
							) : null}
						</Grid>
					</Grid>
				);
			})}
		</div>
	);
};

export default ChangeLogo;
